export default __webpack_public_path__ + "static/media/level-1.784bc7ab.png";